import { BrowserRouter as Router, Routes, Route} from 'react-router-dom';
import './styles/App.css';
import '@fontsource/roboto';
import CurrentOrder from './pages/CurrentOrder';
import Bill from './pages/Bill';
import Menu from './pages/Menu';
import Landing from './Landing';
import DrawerAppBar from './Navigation';
import SignIn from './pages/SignIn';
import SignUp from './pages/SignUp';
import StaffRoute from './components/StaffRoute';
import KitchenStaff from './pages/KitchenStaff';
import WaitStaff from './pages/WaitStaff';
// import Category from './pages/Category';
import CategoryM from './pages/CategoryM';
import Dish from './pages/Dish';
import DishM from './pages/DishM';
import '@fontsource/roboto';
import Profile from './pages/Profile';
import ManagerRoute from './components/ManagerRoute';
import ManagerEmployeeManagement from './pages/ManagerPages/ManagerEmployeeManagement';
import EditMenu from './pages/EditMenu';
import AddDish from './pages/AddDish';

export function App() {
  return (
    <>
      <Router>
        <DrawerAppBar></DrawerAppBar>
        <Routes>
            <Route path='/' element={<Landing/>}/>
            <Route path='/home' element={<Landing/>}/>
            <Route path='/menu' element={<Menu/>}/>
              <Route path='/menu/:dishName' element={<Dish/>}/>
            <Route path='/order' element={<CurrentOrder/>}/>
            <Route path='/bill' element={<Bill/>}/>
            <Route path='/sign-in' element={<SignIn/>} />
            <Route element={<StaffRoute />}>
              <Route path='/wait-staff-page' element={<WaitStaff />} />
              <Route path='/kitchen-staff-page' element={<KitchenStaff />} />
              <Route path='/profile' element={<Profile />} />
            </Route>
            <Route element={<ManagerRoute />}>
              <Route path='/sign-up' element={<SignUp/>} />
              <Route path='employee-management' element={<ManagerEmployeeManagement />} />
              <Route path='/edit-menu' element={<EditMenu/>} />
                <Route path='/profile/edit-menu/add-dish' element={<AddDish/>}/>
                <Route path='/edit-menu/:categoryName' element={<CategoryM/>}/>
                  <Route path='/edit-menu/:categoryName/:dishName' element={<DishM/>}/>
            </Route>
            <Route path='/dev/wait-staff' element={<WaitStaff />} />
            <Route path='/dev/kitchen-staff' element={<KitchenStaff />} />
        </Routes>
      </Router>
      </>
  );
}
